const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6769_239003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 13.3346V10.0012M9.99998 6.66789H10.0083M3.20831 7.18455C3.08668 6.63666 3.10536 6.06692 3.26261 5.52817C3.41986 4.98942 3.7106 4.49909 4.10787 4.10266C4.50514 3.70622 4.99607 3.41651 5.53515 3.26038C6.07423 3.10426 6.64401 3.08677 7.19164 3.20955C7.49307 2.73814 7.90831 2.35019 8.3991 2.08146C8.88989 1.81273 9.44043 1.67187 9.99998 1.67188C10.5595 1.67187 11.1101 1.81273 11.6009 2.08146C12.0916 2.35019 12.5069 2.73814 12.8083 3.20955C13.3568 3.08624 13.9275 3.10364 14.4675 3.26015C15.0074 3.41665 15.499 3.70717 15.8965 4.10468C16.294 4.50219 16.5845 4.99378 16.741 5.53372C16.8976 6.07366 16.915 6.64441 16.7916 7.19289C17.2631 7.49431 17.651 7.90956 17.9197 8.40035C18.1885 8.89114 18.3293 9.44168 18.3293 10.0012C18.3293 10.5608 18.1885 11.1113 17.9197 11.6021C17.651 12.0929 17.2631 12.5081 16.7916 12.8096C16.9144 13.3572 16.8969 13.927 16.7408 14.466C16.5847 15.0051 16.295 15.4961 15.8985 15.8933C15.5021 16.2906 15.0118 16.5813 14.473 16.7386C13.9343 16.8958 13.3645 16.9145 12.8166 16.7929C12.5156 17.2661 12.1 17.6557 11.6084 17.9257C11.1168 18.1956 10.565 18.3371 10.0041 18.3371C9.44329 18.3371 8.8915 18.1956 8.39987 17.9257C7.90825 17.6557 7.49268 17.2661 7.19164 16.7929C6.64401 16.9157 6.07423 16.8982 5.53515 16.7421C4.99607 16.5859 4.50514 16.2962 4.10787 15.8998C3.7106 15.5034 3.41986 15.013 3.26261 14.4743C3.10536 13.9355 3.08668 13.3658 3.20831 12.8179C2.73327 12.5173 2.34199 12.1014 2.07085 11.6089C1.79971 11.1164 1.65753 10.5634 1.65753 10.0012C1.65753 9.43905 1.79971 8.88601 2.07085 8.39354C2.34199 7.90108 2.73327 7.48518 3.20831 7.18455Z",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6769_239003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeInfo);
export default __webpack_public_path__ + "static/media/badge-info.04fc7c43bccf4d45ee6153e58049c905.svg";
export { ForwardRef as ReactComponent };